import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=22b56258&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./assets/css/edit.scss?vue&type=style&index=0&id=22b56258&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b56258",
  null
  
)

export default component.exports